/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .error-page[_ngcontent-%COMP%] {\n  margin: auto 0;\n  padding-top: 25vw;\n  height: 100vh;\n  width: 100vw;\n  text-align: center;\n  vertical-align: middle;\n}\n[_nghost-%COMP%]   .error-page[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%] {\n  margin-bottom: 10px;\n  font-size: 3.5vw;\n  font-weight: 300;\n}\n[_nghost-%COMP%]   .error-page[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%] {\n  margin-bottom: 10px;\n  font-size: 2vw;\n  font-weight: 300;\n}"];
export { styles as styles };
